import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useAuth } from '@modules/auth/hooks';
import { AVAILABLE_TIME_RANGES_KEY } from '../constants';
import { fetchAvailableTimeRanges } from '@modules/genetic-counseling/services';
import { AvailableTimeRangesResponse, UseQueryAvailableTimeRangesParams } from '../types';

const useQueryAvailableTimeRanges = <TError = unknown>(
  params: UseQueryAvailableTimeRangesParams,
  options?: Omit<
    UseQueryOptions<
      AvailableTimeRangesResponse | undefined,
      TError,
      AvailableTimeRangesResponse | undefined,
      Array<string | UseQueryAvailableTimeRangesParams>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<AvailableTimeRangesResponse | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([AVAILABLE_TIME_RANGES_KEY, params], async () => await fetchAvailableTimeRanges(params), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQueryAvailableTimeRanges;
